import { Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AdminLayout from './layouts/AdminLayout';
import Register from './pages/Register';
import ProtectedRoute from './components/ProtectedRoute';
import OrderList from './pages/OrderList';
import OrderDetail from './pages/OrderDetail';
import ProductList from './pages/ProductList';
import ProductDetail from './pages/ProductDetail';
import EditProduct from './pages/EditProduct';
import AddProduct from './pages/AddProduct';
import ReorderProducts from './pages/ReorderProducts';
import Stats from './pages/Stats';
import EditProfile from './pages/EditProfile';
import { AuthProvider } from './contexts/AuthContext';
import BankDetails from './pages/BankDetails';
import Notifications from './pages/Notifications';
import SizeChartsPage from './pages/sizeChart/listSizeCharts';
import MySettlements from './pages/MySettlements';
import SettlementDetail from './pages/SettlementDetail';
import MySupportTickets from './pages/support/MySupportTickets';
import RaiseNewTicket from './pages/support/RaiseNewTicket';
import TicketDetail from './pages/support/TicketDetail';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <AuthProvider>
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        <Route path="/" element={<ProtectedRoute><AdminLayout><Dashboard /></AdminLayout></ProtectedRoute>} />
        <Route path="/orders" element={<ProtectedRoute><AdminLayout><OrderList /></AdminLayout></ProtectedRoute>} />
        <Route path="/orders/:id" element={<ProtectedRoute><AdminLayout><OrderDetail /></AdminLayout></ProtectedRoute>} />
        <Route path="/products" element={<ProtectedRoute><AdminLayout><ProductList /></AdminLayout></ProtectedRoute>} />
        <Route path="/products/add" element={<ProtectedRoute><AdminLayout><AddProduct /></AdminLayout></ProtectedRoute>} />
        <Route path="/products/reorder" element={<ProtectedRoute><AdminLayout><ReorderProducts /></AdminLayout></ProtectedRoute>} />
        <Route path="/products/arrange" element={<ProtectedRoute><AdminLayout><ReorderProducts /></AdminLayout></ProtectedRoute>} />
        <Route path="/products/:id" element={<ProtectedRoute><AdminLayout><ProductDetail /></AdminLayout></ProtectedRoute>} />
        <Route path="/products/edit/:id" element={<ProtectedRoute><AdminLayout><EditProduct /></AdminLayout></ProtectedRoute>} />
        <Route path="/stats" element={<ProtectedRoute><AdminLayout><Stats /></AdminLayout></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><AdminLayout><EditProfile /></AdminLayout></ProtectedRoute>} />
        <Route path="/bank-details" element={<ProtectedRoute><AdminLayout><BankDetails /></AdminLayout></ProtectedRoute>} />
        <Route path="/notifications" element={<ProtectedRoute><AdminLayout><Notifications /></AdminLayout></ProtectedRoute>} />
        <Route path="/size-charts" element={<ProtectedRoute><AdminLayout><SizeChartsPage /></AdminLayout></ProtectedRoute>} />
        <Route path="/settlements" element={<ProtectedRoute><AdminLayout><MySettlements /></AdminLayout></ProtectedRoute>} />
        <Route path="/settlements/:brandID/:month" element={<ProtectedRoute><AdminLayout><SettlementDetail /></AdminLayout></ProtectedRoute>} />
        
        {/* Support Routes */}
        <Route path="/support" element={<ProtectedRoute><AdminLayout><MySupportTickets /></AdminLayout></ProtectedRoute>} />
        <Route path="/support/new" element={<ProtectedRoute><AdminLayout><RaiseNewTicket /></AdminLayout></ProtectedRoute>} />
        <Route path="/support/details/:ticketNo" element={<ProtectedRoute><AdminLayout><TicketDetail /></AdminLayout></ProtectedRoute>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
